import type { ApplyChannelData } from '@/api/apply-product/types';
import type { quickLoanChannelType } from '@/api/quick-withdraw/types';
import { getCheckResult } from '@/api/rights';
import { GetRightSummaryType, RightPackageTypeEnum } from '@/api/rights/types';
import ProductCommodity from '@/shared/commodity';

/** 判断自营是否需要购买权益
 * @returns result { needRight: boolean; packageType?: RightPackageTypeEnum; }
 * @param channel { ApplyChannelData } 渠道信息
 */
export const calcAutarkyNeedRight = (channel: ApplyChannelData | quickLoanChannelType): {
  needRight: boolean;
  packageType?: RightPackageTypeEnum;
} => {
  if (channel?.productId === ProductCommodity.AUTARKY_B_COMMODITY && channel?.capitalList) {
    const [capitalFirstList] = channel.capitalList;
    const checkResult = {
      needRight: !!(channel && capitalFirstList?.needRight),
      packageType: capitalFirstList?.packageType,
    };
    return checkResult;
  }

  return { needRight: false };
};


/** 判断联营是否需要购买权益
 * @returns result { needRight: boolean; packageType?: RightPackageTypeEnum; }
 * @param params { GetRightSummaryType } 获取联营是否需要购买权益的参数
 */
export const calcUnionChannelNeedRight = async (params: GetRightSummaryType): Promise<{
needRight: boolean;
packageType?: RightPackageTypeEnum;
}> => {
  try {
    const result = await getCheckResult({
      ...params,
    });
    return {
      needRight: result.checkResult,
      packageType: RightPackageTypeEnum.CHANNEL_B,
    };
  } catch (error) {
    return { needRight: false };
  }
};
